"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultProfileName = getDefaultProfileName;
const get_name_of_user_1 = __importDefault(require("./get-name-of-user"));
function getDefaultProfileName(user) {
    var _a;
    return (user.profileName ||
        ((_a = user.data) === null || _a === void 0 ? void 0 : _a.profileName) ||
        (0, get_name_of_user_1.default)(user) ||
        undefined);
}
